import React from "react";
import { Button } from "react-bootstrap";

export default function ScrollToTopButton({ onClick }) {
  return (
    <Button
      variant="primary"
      onClick={onClick}
      className="scroll-to-top-btn"
      style={{
        position: "fixed",
        bottom: "40px",
        right: "40px",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        padding: 0,
        zIndex: 1000,
      }}
    >
      <i className="mdi mdi-arrow-up" style={{ fontSize: "1.5rem" }} />
    </Button>
  );
}
